module.exports = __webpack_public_path__ + "img/safr.07baf45f.png";